import 'reflect-metadata';
import { GlobalRegistry } from '@mrbilit/vue-context-provider';
import {
    dayConfig,
    formatMoney,
    useAuthStore,
    validateIban,
    validateCreditCard,
    useAnalyticsStore,
    usePostHog,
} from '#imports';
import useBaseUrls from '@composable/useBaseUrls';

export default defineNuxtPlugin(() => {
    GlobalRegistry.registerValue(dayConfig, 'dayConfig');
    GlobalRegistry.registerValue(useAuthStore(), 'authStore');
    GlobalRegistry.registerValue(useAnalyticsStore(), 'analyticsStore');
    GlobalRegistry.registerValue(usePostHog(), 'posthog');
    GlobalRegistry.registerValue(useBaseUrls(), 'baseUrls');
    GlobalRegistry.registerValue(formatMoney, 'formatMoney');
    GlobalRegistry.registerValue(validateIban, 'validateIban');
    GlobalRegistry.registerValue(validateCreditCard, 'validateCreditCard');
});
